import styled from "@emotion/styled";

export const LogoWrapper = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  margin-right: ${({ theme }) => theme.spacing.lg || "2rem"};

  @media (max-width: 48rem) {
    font-size: ${({ theme }) => theme.typography?.sizes?.md || "1.25rem"};
  }
`;
